/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Door_Guided_CtaInputs */

const en_simple_door_guided_cta = /** @type {(inputs: Simple_Door_Guided_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask for guidance`)
};

const id_simple_door_guided_cta = /** @type {(inputs: Simple_Door_Guided_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta pendampingan`)
};

/**
* | output |
* | --- |
* | "Ask for guidance" |
*
* @param {Simple_Door_Guided_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_guided_cta = /** @type {((inputs?: Simple_Door_Guided_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Guided_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_guided_cta(inputs)
	return en_simple_door_guided_cta(inputs)
});